module.exports = __webpack_public_path__ + "static/media/KfLogoIllustr.b38a69eb.svg";